import React from 'react';
import PropTypes from 'prop-types';
import {Image, Menu} from 'semantic-ui-react';

import AutoSaveDropdown from './AutoSaveDropdown';
import ImageButtons from 'components/images/ImageButtons';
import {EmptyFunc, makeDBContentImageUrl} from "utils/DBUtils";
import FieldStatusIcon from "../FieldStatusIcon";
import {isBlank} from "../../../utils/DBUtils";

class AutoSaveImagePicker extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            selectedImageId: this.hasValidDefaultValue ? this.props.defaultValue : this.props.linkedValue
        };
    }

    componentWillReceiveProps(nextProps, context) {
      if ( !isBlank(nextProps.defaultValue)
          && nextProps.defaultValue !== this.state.selectedImageId) {
        this.setState({ selectedImageId: nextProps.defaultValue });
      }else if ( nextProps.usingLinkedValue && nextProps.linkedValue && nextProps.linkedValue !== this.state.selectedImageId) {
        this.setState({ selectedImageId: nextProps.linkedValue });
      }
    }

    selectImage(imageId) {
        if (this.state.selectedImageId === imageId) {
            return;
        }

        this.setState({
            selectedImageId: imageId
        });

        this.props.onValueChanged(imageId, this.props.name)
    }

    editImage = () => {
        if (this.props.editImage) {
            this.props.editImage();
        }
    };

    editImageInfo = () => {
        if (this.props.editImageInfo) {
            this.props.editImageInfo();
        }
    };

    get hasValidDefaultValue() {
      return !isBlank(this.props.defaultValue);
    }

    onValidationSuccess = (field, platform) => {
        this.props.onValidationSuccess(this.state.selectedImageId, platform);
    };

    render() {
        let selectedImage = null;
        let renderImage = false;
        if (this.state.selectedImageId) {
            selectedImage = this.props.getPossibleImages().find((item) => item.id === this.state.selectedImageId);
            // If selected image is one of the possible images
            // then only render if it isn't an original
            // else always render because it is the current value of the image field which shouldn't be an original
            renderImage = selectedImage ? selectedImage.imageType !== "original" : true;
        }

        let hasOriginalImage = this.props.hasOriginalImage;

        let labelKey = this.props.labelKey;
        if (this.props.field && this.props.field.labelKey) {
            labelKey = this.props.field.labelKey;
        }

        return (
            <div className="autosave-image-picker">
                <AutoSaveDropdown defaultValue={this.state.selectedImageId || null}
                                  currentPlatform={this.props.currentPlatform}
                                  placeholder={"-- Select Image --"}
                                  name={this.props.name}
                                  required={this.props.required}
                                  disabled={this.props.loading === true || this.props.editable === false}
                                  labelKey={labelKey}
                                  savedField={this.props.savedField}
                                  isSaving={this.props.isSaving}
                                  errors={this.props.errors}
                                  onValidationError={this.props.onValidationError}
                                  onValidationSuccess={this.onValidationSuccess}
                                  onPersistValue={(value, field) => this.selectImage(value)}
                                  fieldLabel={this.props.fieldLabel}
                                  options={this.props.getImageOptions()}
                                  helpContent={this.props.helpContent}
                                  helpHeader={this.props.helpHeader} />
                {this.state.selectedImageId && !this.props.loading ? (
                    <section className="image-picker-preview">
                        {renderImage ? <Image src={makeDBContentImageUrl(this.state.selectedImageId)}/> : ""}
                        <div className="image-preview-controls">
                            <Menu.Item disabled={this.props.editable === false} onClick={() => this.selectImage(null)}>Remove</Menu.Item>
                            |
                            &nbsp;<Menu.Item disabled={this.props.editable === false} onClick={this.editImageInfo}>Edit Info</Menu.Item>&nbsp;
                            {hasOriginalImage ? (
                                <React.Fragment>
                                    |
                                    <Menu.Item disabled={this.props.editable === false} onClick={this.editImage}>Edit Image</Menu.Item>
                                </React.Fragment>
                            ) : ""}
                        </div>
                        { this.props.helperText && (!!!this.props.hideHelperText) && <div style={{marginBottom: "6px", fontSize: "14px"}}>{this.props.helperText}</div>}
                    </section>
                ) : (this.props.loading ?
                        <div className="creating-image-info">
                            <p>Creating image <FieldStatusIcon error={false} saved={true} isSaving={true} show={true}/></p>
                        </div>
                        : (
                        <React.Fragment>
                        <ImageButtons disabled={this.props.isUploading}
                                  onBrowse={this.props.onBrowse}
                                  onIdEntered={(value) => this.selectImage(value)}/>
                        { this.props.helperText && (!!!this.props.hideHelperText) && <div style={{marginBottom: "6px", fontSize: "14px"}}>{this.props.helperText}</div>}
                        </React.Fragment>
                    ))}
            </div>
        );
    }
}

AutoSaveImagePicker.propTypes = {
    name: PropTypes.string.isRequired,
    isUploading: PropTypes.bool,
    defaultValue: PropTypes.string,
    possibleImages: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })),
    onValueChanged: PropTypes.func,
    onBrowse: PropTypes.func,
    editImageInfo: PropTypes.func,
    editImage: PropTypes.func,
    imageType: PropTypes.string.isRequired,
    idAssetValue: PropTypes.any
};

AutoSaveImagePicker.defaultProps = {
    isUploading: false,
    possibleImages: [],
    onValueChanged: EmptyFunc,
    onBrowse: EmptyFunc
};

export default AutoSaveImagePicker;



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveImagePicker.jsx